const ANNOUNCEMENT_SESSION_KEY_PREFIX =
  "cocoPortal.announcementShown.loginPopup.v3";

const getAuthenticatedIdentity = (user) =>
  user?.userId ||
  user?.portalUserId ||
  user?.cognitoUserId ||
  user?.email ||
  user?.username ||
  "authenticated-user";

const FALLBACK_DISMISSED_KEY_PREFIX = "cocoPortal.noticeDismissed";

const encodeIdentity = (user) => encodeURIComponent(String(getAuthenticatedIdentity(user)));

export const getAnnouncementSessionKey = (user) =>
  `${ANNOUNCEMENT_SESSION_KEY_PREFIX}:${encodeURIComponent(
    String(getAuthenticatedIdentity(user)),
  )}`;

export const hasShownAnnouncement = (user) => {
  try {
    return sessionStorage.getItem(getAnnouncementSessionKey(user)) === "true";
  } catch (error) {
    return false;
  }
};

export const markAnnouncementShown = (user) => {
  try {
    sessionStorage.setItem(getAnnouncementSessionKey(user), "true");
  } catch (error) {
    // The announcement still works for this mount when storage is unavailable.
  }
};

export const clearAnnouncementShown = (user) => {
  try {
    sessionStorage.removeItem(getAnnouncementSessionKey(user));
  } catch (error) {
    // Signing out must not depend on browser storage availability.
  }
};

// "Não mostrar novamente" while GET /notifications is down: remembered per user in
// localStorage as "<key>@<version>", so a new version of a notice shows again.
export const getFallbackDismissedStorageKey = (user) =>
  `${FALLBACK_DISMISSED_KEY_PREFIX}:${encodeIdentity(user)}`;

const toDismissedId = (notice) => `${notice.key}@${notice.version || 1}`;

const readFallbackDismissed = (user) => {
  try {
    const stored = JSON.parse(localStorage.getItem(getFallbackDismissedStorageKey(user)));
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
};

export const isFallbackNoticeDismissed = (user, notice) =>
  Boolean(notice?.key) && readFallbackDismissed(user).includes(toDismissedId(notice));

export const dismissFallbackNotices = (user, notices = []) => {
  const ids = notices.filter((notice) => notice?.key).map(toDismissedId);
  if (!ids.length) return;
  const next = Array.from(new Set([...readFallbackDismissed(user), ...ids]));
  try {
    localStorage.setItem(getFallbackDismissedStorageKey(user), JSON.stringify(next));
  } catch (error) {
    // Without storage the notice simply shows again next login.
  }
};
